import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VueStore from "../../store/VueStore";
import axios from "axios";
import timeZoneConfig from "../../common/scripts/time_zone_config";
import { saveUserSetting } from "./scripts/save_user_setting";
import { clearReloadEvents } from "./scripts/clear_reload_events";
import { checkChangeComponent } from "./scripts/check_change_component";
import router from "../../router";
import { Auth } from "aws-amplify";
import LanguageSettingConfig from "@/language/language_config"
import { downloadCsvForSpread } from "./scripts/download_csv_for_spread";

@Component({})
export default class HeaderContent extends Vue {
  [key: string]: any;
  public token: string = VueStore.state.token;
  public headerElement: boolean = true;
  public userSettingModal: boolean = false;
  public switchContentModal: boolean = false;
  public useSignal: boolean = VueStore.state.useSignal;
  public usePresence: boolean = VueStore.state.usePresence;
  // スプレッド様向けカスタム機能用の変数定義
  public userIsSpread: boolean = VueStore.state.userIsSpread;
  public downloadCSVForSpreadModal: boolean = false;
  public downloadingCsvForSpread: boolean = false;
  public downloadCsvForSpreadFromDate: Date = null;
  public downloadCsvForSpreadToDate: Date = null;
  public downloadCsvForSpreadFromDateDefaultTimeFrom: string = "00:00:00";
  public downloadCsvForSpreadToDateDefaultTimeTo: string = "23:59:59";
  public timeZone: string = VueStore.state.useTimeZone;
  public timeZones = timeZoneConfig;
  public selectedLanguage: string = this.$root.$i18n.locale;
  public languageChoices: Array<{[key: string]: string}> = LanguageSettingConfig.languageChoices()
  public date: string = "";
  public submitHeaderButton: boolean = true;
  public submitHeaderWait: boolean = false;
  public submitHeaderComplete: boolean = false;
  public pageTitle: string = "グラフ画面";
  public selectItem: string = "graph";
  // !selectOptions変数内の配列順はcreated()関数内のpageTitles変数内の配列順と相互関係にあります
  public selectOptions = [
    {
      text: "グラフ画面",
      value: "graph",
      action: "moveGraphPage",
      enable: true
    },
    {
      text: "パトランプ(パネル)",
      value: "signal",
      action: "moveSignalPage",
      enable: VueStore.state.useSignal
    },
    {
      text: "パトランプ(マッピング)",
      value: "signalMapping",
      action: "moveIndexSignalMappingPage",
      enable: VueStore.state.useSignal
    },
    {
      text: "席ティア - マッピング画面",
      value: "seatMapping",
      action: "moveSeatMappingPage",
      enable: VueStore.state.usePresence
    },
  ];
  public demandBody: string = "";
  public sendDemandModal: boolean = false;

  public created() {
    // !pageTitles変数内の配列順はメンバ変数のselectOptions内の配列順と相互関係にあります
    const pageTitles = [
        this.$t("message.graphs"),
        this.$t("message.stackLightPanels"),
        this.$t("message.stackLightMap"),
        this.$t("message.seatMap"),
    ]
    let i = 0;
    for (const value of pageTitles) {
      this.selectOptions[i].text = value as string;
      this.$set(this.selectOptions, i, this.selectOptions[i]);
      i++;
    }
    this.getNowDate();
    this.getCurrentRoot();
  }

  /**
   * サインアウト
   */
  public signOut() {
    this.headerElement = false;
    clearReloadEvents(this);
    Auth.signOut().then(() => {
      return router.push("/signIn");
    }).catch((err: any) => {
      console.error(err);
    });
  }

  /**
   * 現在時刻を取得する
   */
  public getNowDate() {
    setInterval(() => {
      this.date = moment().format("YYYY-MM-DD HH:mm:ss");
    }, 1000);
  }

  /**
   * 今表示中のpathを取得する
   */
  public getCurrentRoot() {
    const currentRoot = this.$route.path;
    if (currentRoot === "/") {
      this.selectItem = "graph";
    } else if (currentRoot === "/signal") {
      this.selectItem = "signal";
    } else if (currentRoot === "/signalMapping") {
      this.selectItem = "signalMapping";
    } else if (currentRoot === "/seatMapping") {
      this.selectItem = "seatMapping";
    }
  }
  /**
   * スプレッド様用全デバイスサマリデータダウンロードモーダルの表示切り替え
   */
  public switchDownloadCsvForSpread() {
    this.downloadCSVForSpreadModal = !this.downloadCSVForSpreadModal;
    // UIのためにデフォルトでは前日がすでに指定されているようにする
    if (this.downloadCsvForSpreadFromDate === null) {
      const yesterday: string = new Date(new Date().getTime() - 60 * 1000 * 60 * 24).toLocaleDateString();
      this.downloadCsvForSpreadFromDate = new Date(yesterday + " " + this.downloadCsvForSpreadFromDateDefaultTimeFrom);
      this.downloadCsvForSpreadToDate = new Date(yesterday + " " + this.downloadCsvForSpreadToDateDefaultTimeTo);
    }
  }

  /**
   * スプレッド様用CSVダウンロードボタンのクリック処理
   */
    public async clickDownloadSummaryCsvForSpread() {
      // トークンがnullの場合はサインイン画面に戻す
      if (VueStore.state.token === null) {
        return router.push("/signIn");
      }
      // 特定ユーザーフラグが立っていなければダウンロード処理実行しない
      else if (VueStore.state.userIsSpread !== true) {
        return alert(this.$t("message.theUserIsNotAuthorizedForTheOperation"));
      }
      // CSVダウンロード処理の実行
      await downloadCsvForSpread(this);
    }

  /**
   * ユーザ設定項目の表示切り替え
   */
  public displayUserSetting() {
    this.userSettingModal = !this.userSettingModal;
  }

  public displaySendDemand() {
    this.sendDemandModal = !this.sendDemandModal;
  }

  /**
   * モバイル用メニュークリック処理
   * @param command クリックボタン
   */
  public handleMenuCommand(command: string) {
    if (command === "userSettings") {
      this.displayUserSetting();
    } else if (command === "switchOperation") {
      this.switchContentModal = true;
    } else if (command === "signOut") {
      this.signOut();
    }
  }

  /**
   * ユーザ設定を保存
   */
  public async commitUserSetting() {
    const self = this;
    LanguageSettingConfig.saveLanguageSettingToStorages(this.selectedLanguage);
    await saveUserSetting(self);
    this.userSettingModal = false;
  }

  // commitDemand()は使われていない関数(20230525時点)
  public async commitDemand() {
    this.submitHeaderButton = false;
    this.submitHeaderWait = true;

    try {
      const body = {
        text: this.demandBody,
      };
      const requestBody = {
        method: "post",
        url:
          "https://hooks.slack.com/services/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",
        data: JSON.stringify(body),
      };
      const apiResponse = await axios(requestBody);
      console.log(apiResponse);
      this.submitHeaderWait = false;
      this.submitHeaderComplete = true;
      setTimeout(() => {
        this.submitHeaderComplete = false;
        this.submitHeaderButton = true;
      }, 3000);
    } catch (err) {
      console.error(err);
      alert(this.$t("message.failedToSendData"));
    }
  }

  /**
   * headerのリンクを切り替えたときの処理
   */
  public changeEvent() {
    if (this.selectItem === "graph") {
      this.moveGraphPage();
    } else if (this.selectItem === "signal") {
      this.moveSignalPage();
    } else if (this.selectItem === "signalMapping") {
      this.moveIndexSignalMappingPage();
    } else if (this.selectItem === "flashAir") {
      this.moveFlashAirDemoPage();
    } else if (this.selectItem === "meshDemo") {
      this.moveMeshDemoPage();
    } else if (this.selectItem === "seatMapping") {
      this.moveSeatMappingPage();
    }
    this.switchContentModal = false;
  }

  /**
   * graph画面切り替え
   */
  public moveGraphPage() {
    this.pageTitle = "グラフ画面";
    checkChangeComponent("/", this);
    return router.push("/");
  }

  public moveIndexSignalMappingPage() {
    this.pageTitle = "マッピング画面";
    checkChangeComponent("/signalMapping", this);
    return router.push("/signalMapping");
  }

  /**
   * パトランプ画面切り替え
   */
  public moveSignalPage() {
    this.pageTitle = "パトランプ画面";
    checkChangeComponent("/signal", this);
    return router.push("/signal");
  }

  /**
   * FlasfAir画面切り替え
   */
  public moveFlashAirDemoPage() {
    this.pageTitle = "Flash Airデモ";
    return router.push("/flashAirDemo");
  }

  /**
   * Mesh画面切り替え
   */
  public moveMeshDemoPage() {
    this.pageTitle = "Meshデモ";
    return router.push("/mesh");
  }

  /**
   * パトランプ画面切り替え
   */
  public moveSeatMappingPage() {
    this.pageTitle = "席ティア - マッピング画面";
    checkChangeComponent("/seatMapping", this);
    return router.push("/seatMapping");
  }
}
